import type { ContentTypeObject, CustomHtmlElement } from '../../types/pbTypes';
import { getAdvanced, parseStyleString } from '../utils';
import { PbMap } from '../../types/pbBlocks';

export type MapType = ContentTypeObject & PbMap;

/**
 * Aggregates the configuration of a dynamic block element.
 * @param node
 */
export function mapConfigAggregator(node: CustomHtmlElement): MapType {
    const style = parseStyleString(node.attributes.style);
    const locations = node.attributes['data-locations'];

    return {
        ...getAdvanced(node, style),
        height: style?.height,
        locations: JSON.parse(locations),
        showControls: node.attributes['data-show-controls'] === 'true',
        uniqueID: node.attributes['data-pb-style'],
    };
}
